import {createContext, useContext} from 'react';

import {withContextBuilder} from '../../../../libs/shared/helpers/src/react/reactHelpers';

/*
 * Type.
 */

export enum DeviceTypesEnum {
  DESKTOP,
  MOBILE,
}

export interface PlatformProps {
  device: DeviceTypesEnum;
}

/*
 * Context.
 */

export const PlatformContext = createContext<PlatformProps>({
  device: DeviceTypesEnum.DESKTOP,
});

/*
 * Hook.
 */

export function usePlatform() {
  return useContext(PlatformContext);
}

/*
 * HOC.
 */

export const withPlatform = withContextBuilder(PlatformContext);
